import { ActionReducerMap } from '@ngrx/store';
import * as fromAuth from './auth/auth.reducer';

export interface AuthModuleState {
  auth: fromAuth.State;
}

export const reducers: ActionReducerMap<AuthModuleState> = {
  auth: fromAuth.reducer
};
